/**
 * Data-attribute hook used by the RGL host to identify the widget's drag
 * handle. react-grid-layout's `dragConfig.handle` selector references
 * `WIDGET_DRAG_HANDLE_SELECTOR` — see `ReactGridLayoutTab.pres.tsx`.
 * The grab / grabbing cursor is keyed off the same attribute in `widget.css`;
 * beyond that the attribute only tags the element so the engine can find it.
 *
 * Kept in its own module (rather than exported from `index.tsx`) so
 * `WidgetActionsMenu.test.tsx` and other siblings can import the constants
 * without pulling in `Widget/index.tsx` and risking a circular import.
 */
export const WIDGET_DRAG_HANDLE_ATTR = "data-widget-drag-handle";

/** CSS selector for RGL `handle` options. */
export const WIDGET_DRAG_HANDLE_SELECTOR = `[${WIDGET_DRAG_HANDLE_ATTR}]`;
